<template lang="pug">
  span(v-if="data.is_stopped_on_text_reply === true") Yes
</template>
<script>
export default {
  props: ['data'],
};
</script>
